exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PatientConsentForMedicalRecordsExchange--1h716kVNIhRd6KBGvpu4I_ {\n  background-color: #d1edf6;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.PatientConsentForMedicalRecordsExchange--1EXlw509ZcVYgKokKV2fdu {\n  margin-top: 35px;\n}\n\n.PatientConsentForMedicalRecordsExchange--35bYFQt6u9CgK1MS4JcwFa label {\n  margin-top: 10px;\n  color: #7c7d74;\n  font-weight: normal;\n}\n\n.PatientConsentForMedicalRecordsExchange--tfaUg6ZFQXoUgiCiXUOP9 {\n  margin-right: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"editPatientConsentForm": "PatientConsentForMedicalRecordsExchange--1h716kVNIhRd6KBGvpu4I_",
	"editPatientConsentForm": "PatientConsentForMedicalRecordsExchange--1h716kVNIhRd6KBGvpu4I_",
	"editPatientConsentFormButtons": "PatientConsentForMedicalRecordsExchange--1EXlw509ZcVYgKokKV2fdu",
	"editPatientConsentFormButtons": "PatientConsentForMedicalRecordsExchange--1EXlw509ZcVYgKokKV2fdu",
	"editPatientConsentFormInput": "PatientConsentForMedicalRecordsExchange--35bYFQt6u9CgK1MS4JcwFa",
	"editPatientConsentFormInput": "PatientConsentForMedicalRecordsExchange--35bYFQt6u9CgK1MS4JcwFa",
	"editPatientConsentFormCheckbox": "PatientConsentForMedicalRecordsExchange--tfaUg6ZFQXoUgiCiXUOP9",
	"editPatientConsentFormCheckbox": "PatientConsentForMedicalRecordsExchange--tfaUg6ZFQXoUgiCiXUOP9"
};